import styled from 'styled-components';
import { DropdownHeadingMixin } from '../../mixins/components/DropdownHeadingMixin';
import { Flex } from '../Flex/Flex';
export var StyledDropdownHeading = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "StyledDropdownHeading",
  componentId: "c11n-8-111-1__sc-i8acda-0"
})(["", ""], DropdownHeadingMixin);